export const getLabelStyle = (theme) => (Object.assign({}, theme.typography.labelMedium));
